import {Component, EventEmitter, Input, Output} from '@angular/core';
import {RegisterCompanyStepBase} from '../register-company-step.base';

@Component({
    selector: 'app-register-company-terms',
    templateUrl: './terms-step.component.html',
    styleUrls: ['../../register-company.component.scss']
})
export class RegisterCompanyTermsStepComponent extends RegisterCompanyStepBase {

    @Input() companyTermsAndCondition1 = false;
    @Input() companyTermsAndCondition2 = false;
    @Input() companyTermsAndCondition3 = false;

    @Output() companyTermsAndCondition1Change = new EventEmitter<boolean>();
    @Output() companyTermsAndCondition2Change = new EventEmitter<boolean>();
    @Output() companyTermsAndCondition3Change = new EventEmitter<boolean>();

    submitted = false;

    get acceptedTermsCount(): number {
        return [
            this.companyTermsAndCondition1,
            this.companyTermsAndCondition2,
            this.companyTermsAndCondition3,
        ].filter(Boolean).length;
    }

    get allTermsAccepted(): boolean {
        return this.acceptedTermsCount === 3;
    }

    consentCardClass(accepted: boolean): string {
        if (accepted) return '!border-primary/40 !bg-primary-soft';
        if (this.submitted) return '!border-red-300 !bg-red-50';
        return '!border-slate-200 !bg-white';
    }

    onTermChange(index: 1 | 2 | 3, value: boolean): void {
        if (index === 1) {
            this.companyTermsAndCondition1 = value;
            this.companyTermsAndCondition1Change.emit(value);
        } else if (index === 2) {
            this.companyTermsAndCondition2 = value;
            this.companyTermsAndCondition2Change.emit(value);
        } else {
            this.companyTermsAndCondition3 = value;
            this.companyTermsAndCondition3Change.emit(value);
        }
        this.persistForm();
    }

    tryContinue(): void {
        this.submitted = true;
        if (!this.allTermsAccepted) return;
        this.nextStep();
    }
}
